import React from "react";
import "./sheets.scss";
import { Button } from "devextreme-react/button";
import { ProgressBar } from "devextreme-react/progress-bar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import apiAxios from "../../api-axios";
import notify from "devextreme/ui/notify";
import UserInfo from "../../UserInfo";

function statusFormat(value) {
  return `Processamento em andamento: ${value * 100}%`;
}

let intervalId;

class AcompanharProcessamento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: undefined,
      totalProcessamento: undefined,
      tipoResultado: undefined,
      valorCorrente: 0,
      inProgress: false,
      situacao: 0,
    };

    this.situacaoProcessamento = [
      { id: 0, descricao: "Pendente" },
      { id: 1, descricao: "Sucesso" },
      { id: 2, descricao: "Alerta" },
      { id: 3, descricao: "Erro" },
      { id: 4, descricao: "Cancelado" },
      { id: 5, descricao: "Ignorado" },
    ];

    this.onStartLooping = this.onStartLooping.bind(this);
    this.timer = this.timer.bind(this);
    this.cancelarProcessamento = this.cancelarProcessamento.bind(this);
    this.baixarDam = this.baixarDam.bind(this);
  }

  baixarDam() {
    apiAxios
      .get(
        `processamentos/baixar_resultado/${UserInfo.getPrefeitura()}/${
          this.state.id
        }`
      )
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
        }
      });
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      apiAxios
        .get("processamentos/" + this.props.match.params.id)
        .then((response) => {
          if (response.data !== undefined) {
            console.log(response.data);
            this.setState({ ...response.data });
            this.onStartLooping();
          } else {
            notify("Processamento não encontrado!", "error");
            this.props.history.push("/listarprocessamentos");
          }
        })
        .catch((error) => {
          this.props.history.push("/listarprocessamentos");
          console.log(error);
        });
    }
  }

  render() {
    console.log("state", this.state);
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <h3>
            Acompanhar Processamento do Lançamento de código #
            {this.props.match.params.id}
          </h3>
          <div
            className="load-indicator-show"
            style={{
              display: this.state.valorCorrente !== undefined ? "none" : "flex",
              lineHeight: "0px",
            }}
          >
            <h4 style={{ marginRight: "30px" }}>
              Estado: aguardando processamento
            </h4>
            <LoadIndicator id="medium-indicator" height={40} width={40} />
          </div>
          <div
            className="progress-bar-show"
            style={{
              display: this.state.valorCorrente !== undefined ? "" : "none",
              lineHeight: "0px",
            }}
          >
            <ProgressBar
              id="progress-bar-status"
              className={
                this.state.totalProcessamento === this.state.valorCorrente
                  ? "complete"
                  : ""
              }
              width="100%"
              min={0}
              max={this.state.totalProcessamento}
              statusFormat={statusFormat}
              value={this.state.valorCorrente}
            />
            <div>
              <p>Nome: {this.state.nome}</p>
              <br />
              <p>
                Status:{" "}
                {
                  this.situacaoProcessamento.find(
                    (x) => x.id === this.state.situacao
                  ).descricao
                }
              </p>
            </div>
          </div>
          <br />
          <br />
          <div
            className="button-div"
            style={{
              display:
                this.state.valorCorrente === this.state.totalProcessamento
                  ? "none"
                  : "",
            }}
          >
            <Button
              text={"Cancelar Processamento"}
              width={200}
              onClick={this.cancelarProcessamento}
            />
          </div>
          <br />
          <div
            className="button-div"
            style={{ display: this.state.tipoResultado === 1 ? "" : "none" }}
          >
            <Button text={"Baixar DAM"} width={200} onClick={this.baixarDam} />
          </div>
        </div>
      </React.Fragment>
    );
  }

  onStartLooping() {
    intervalId = setInterval(() => this.timer(), 2000);
  }

  cancelarProcessamento() {
    alert("Processamento Cancelado!");
  }

  timer() {
    apiAxios
      .get("processamentos/" + this.props.match.params.id)
      .then((response) => {
        if (response.data !== undefined) {
          this.setState({ ...response.data });

          if (this.state.valorCorrente === this.state.totalProcessamento) {
            clearInterval(intervalId);
          }
        }
      })
      .catch((error) => console.log(error));
  }
}

export default AcompanharProcessamento;
